import React from "react";
import AntdPopover from 'antd/lib/popover';
import { withError} from '@fishx/tracker';

export const Popover = (props) => <AntdPopover {...props} />
Popover.displayName = 'Popover';
export default withError(Popover);



// WEBPACK FOOTER //
// ./src/components/popover/index.tsx